import React from 'react';
import { Meteor } from 'meteor/meteor';
import { isNil, map, isEmpty, forEach, isObject, hasIn, find } from 'lodash';

import * as atlasOps from '../api/Atlas/atlas-operations';

import { urlRegex } from './regex-utils';

import { ATLAS_ELEMENTS } from '../ui/atoms/AtlasAtoms/atlas-elements';

const {
  defaultAtlasSource,
  defaultGraphicSource,
  defaultImageSource,
  defaultMapSource,
  defaultTableSource,
  defaultVideoSource
} = Meteor.settings.public;

const EXTERNAL_LINK_REGEX = new RegExp('ExternalLink');

/**
 * Get atlas props to pass.
 *
 * @param {object} atlasObject - The atlas object.
 * @returns {Array} The atlas props or empty array if not found.
 * @throws {Error} If atlas is null or undefined.
 */
const getAtlasPropsToPass = atlasObject => {
  if (isNil(atlasObject)) throw new Error('atlas not defined');

  const atlasProps = atlasOps.getAtlasProps(atlasObject);
  if (isEmpty(atlasProps)) return [];
  return map(atlasProps, propsToAdd => {
    const propsToPass = {};
    forEach(propsToAdd, ({ propName, propValue }) => {
      if (isObject(propValue) && hasIn(propValue, ['elementProps'])) {
        const { elementName, elementProps } = propValue;
        const { component: childComponent } = find(ATLAS_ELEMENTS.properties, [
          'value',
          elementName
        ]);
        const childProps = { atlas: atlasObject };
        forEach(elementProps, ({ propName: childPropName, propValue: childPropValue }) => {
          childProps[childPropName] = childPropValue;
          if (urlRegex.test(childPropValue)) {
            if (EXTERNAL_LINK_REGEX.test(childPropName))
              propsToPass[`${propName}ExternalURL`] = childPropValue;
            else propsToPass[`${propName}URL`] = childPropValue;
          }
        });
        if (!hasIn(propsToPass, `${propName}URL`)) {
          switch (elementName) {
            case ATLAS_ELEMENTS.ATLASIFRAME:
              propsToPass[`${propName}URL`] = defaultAtlasSource;
              break;
            case ATLAS_ELEMENTS.GRAPHICIFRAME:
              propsToPass[`${propName}URL`] = defaultGraphicSource;
              break;
            case ATLAS_ELEMENTS.IMAGEELEMENT:
              propsToPass[`${propName}URL`] = defaultImageSource;
              break;
            case ATLAS_ELEMENTS.MAPIFRAME:
              propsToPass[`${propName}URL`] = defaultMapSource;
              break;
            case ATLAS_ELEMENTS.TABLEIFRAME:
              propsToPass[`${propName}URL`] = defaultTableSource;
              break;
            case ATLAS_ELEMENTS.VIDEOPLAYER:
              propsToPass[`${propName}URL`] = defaultVideoSource;
              break;
            default:
              propsToPass[`${propName}URL`] = '';
              break;
          }
        }
        propsToPass[propName] = React.cloneElement(childComponent, { ...childProps });
      } else {
        propsToPass[propName] = propValue;
      }
    });
    return propsToPass;
  });
};

export default getAtlasPropsToPass;
